import React from 'react';
import Container from '../Container';
import Button from '../Button';
import AppCard from '../AppCard';
import { applicationsData } from '../../data/applications';
import { Link } from 'react-router-dom';

export default function ApplicationsSection() {
  return (
    <section id="applications" className="py-16 pb-6 bg-bg-application ">
      <Container className="relative z-10 md:pt-16">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-4xl font-bold font-inter text-center text-[#191A15] mb-4">
            Tous les outils dont vous avez besoin
          </h2>
          <p className="text-center text-[#717182] font-regular font-segoe text-base md:text-lg">
            Une suite complète d'applications organisées par domaine
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {applicationsData.map((app, idx) => (
            <AppCard
              key={idx}
              icon={app.icon}
              iconColor={app.iconColor}
              title={app.title}
              description={app.description}
            />
          ))}
        </div>

        <Link to='/applications' className="mt-10 flex justify-center">
          <Button className="bg-[#FEA12BCC] hover:bg-[#FEA12B] text-white px-8 py-3 rounded-full font-medium font-inter">
            Voir toutes les apps
          </Button>
        </Link>
      </Container>
    </section>
  );
}
